import { Component } from '@mycolorway/tao';
import { MDCMenuSurface, Corner } from '@material/menu-surface';

Component('tr-repository-publication-button', {
  ready() {
    const surface = this.querySelector('.mdc-menu-surface');
    this.mdcSurface = new MDCMenuSurface(surface);
    this.mdcSurface.setAnchorCorner(Corner.BOTTOM_LEFT);
  },

  disconnected() {
    if (this.mdcSurface) this.mdcSurface.destroy();
  },
});
